import EventJoin from '../pages/events/EventJoin';
import EventDetail from '../pages/events/EventDetail';
import EventAlbum from '../pages/events/EventAlbum';
import OtpVerification from '../pages/auth/OtpVerification';
import CompleteAccount from '../pages/auth/CompleteAccount';
import InvitationAccept from '../pages/events/InvitationAccept';
import UploadEventImages from '../pages/UploadEventImages';
import Login from '../pages/Login';
import Home from '../pages/Home';
import Profile from '../pages/Profile';
import NotFound from '../pages/NotFound';
import AccountDeletion from '../pages/AccountDeletion';
import AccountSetupRoute from '../components/AccountSetupRoute';
import { 
  HOME,
  ACCOUNT_DELETION,
  PROFILE,
  EVENTS_JOIN, 
  EVENTS_DETAIL,
  EVENTS_ALBUM,
  AUTH_VERIFY_OTP, 
  AUTH_COMPLETE_ACCOUNT, 
  EVENTS_INVITATION_ACCEPT,
  UPLOAD_EVENT_IMAGES,
  LOGIN,
  USER_UPLOADED_IMAGES,
  EVENTS_UPLOAD_JOIN
} from './paths';
import UserUploadedImages from '../pages/UserUploadedImages';

export const routeConfig = [
  { path: EVENTS_DETAIL, element: <EventDetail />, protected: true },
  { path: EVENTS_ALBUM, element: <EventAlbum />, protected: true },
  { path: ACCOUNT_DELETION, element: <AccountDeletion />, protected: false },
  {
    path: PROFILE,
    element: <Profile />,
    protected: true,
    requireCompleteAccount: false,
  },
  {
    path: HOME,
    element: <Home />,
    protected: false,
  },
  {
    path: EVENTS_JOIN,
    element: <EventJoin />,
    protected: false,
  },
  {
    path: EVENTS_UPLOAD_JOIN,
    element: <EventJoin />,
    protected: false,
  },
  {
    path: AUTH_VERIFY_OTP,
    guestOnly: true,
    element: <OtpVerification />,
    protected: false,
  },
  {
    path: AUTH_COMPLETE_ACCOUNT,
    element: <AccountSetupRoute><CompleteAccount /></AccountSetupRoute>,
    protected: false,
  },
  {
    path: EVENTS_INVITATION_ACCEPT,
    element: <InvitationAccept />,
    protected: false,
  },
  {
    path: UPLOAD_EVENT_IMAGES,
    element: <UploadEventImages />,
    protected: true,
    requireCompleteAccount: true,
  },
  {
    path: USER_UPLOADED_IMAGES,
    element: <UserUploadedImages />,
    protected: true,
    requireCompleteAccount: true,
  },
  {
    path: LOGIN,
    guestOnly: true,
    element: <Login />,
    protected: false,
  },
  {
    path: '*',
    element: <NotFound />,
    protected: false,
  },
];
